import { UserFragment } from 'pages/user/api/fragments/generated/User.fragment';

export const useMe = (): UserFragment | undefined => {
  const me = localStorage.getItem('me');
  if (me) {
    return JSON.parse(me);
  }
  return undefined;
};
